import { Middleware } from "@reduxjs/toolkit";
import { identifyUser, clearUserIdentification } from "./userbackClient";
import type { RootState } from "../../store";

export const userbackMiddleware: Middleware = (store) => (next) => (action) => {
  const previousAuth = (store.getState() as RootState).auth;
  const result = next(action);
  const auth = (store.getState() as RootState).auth;
  if (previousAuth !== auth) {
    if (auth.isAuthenticated) {
      identifyUser(auth.email || auth.displayName || "anonymous", {
        name: auth.email,
        email: auth.email,
      });
    } else {
      clearUserIdentification();
    }
  }
  return result;
};
